<template>
  <footer v-if="active"
          role="footer"
          class="footer no-print is-flex"
          :style="isProjectOrStoryPage ?
            { 'position': 'relative' } : { 'position': 'fixed' }">
    <ul class="footer-left is-flex">
      <li v-if="this.isEngCom" class="pb-logo flex-and-center">
        <a class="flex-and-center has-hover"
           :href="this.getUTMLink('https://projectboard.world/','footer')"
           target="_blank"
           tabindex="0"
           aria-label="Go to homepage">
        <p class="is-hidden-touch">{{$t('footer.poweredBy')}}</p>
<!--          <img class="is-hidden-desktop" src="/static/purple-logo-icon.svg"-->
<!--               alt="Project Board Logo"/>-->
<!--          <img class="is-hidden-mobile is-hidden-touch" src="/static/pb-purple-footer-2021.svg"-->
<!--               alt="Project Board Logo"/>-->
          <p class="is-hidden-mobile is-hidden-touch">ProjectBoard</p>
        </a>
      </li>
      <li v-else class="pb-logo flex-and-center">
        <a class="flex-and-center has-hover"
           :href="this.getUTMLink('https://projectboard.world/','footer')"
           target="_blank"
           tabindex="0"
           aria-label="Go to homepage">
        <p class="is-hidden-touch">{{$t('footer.poweredBy')}}</p>
          <img class="is-hidden-desktop" src="/static/purple-logo-icon.svg"
               alt="Project Board Logo"/>
          <img class="is-hidden-mobile is-hidden-touch" src="/static/pb-purple-footer-2021.svg"
               alt="Project Board Logo"/>
        </a>
      </li>
      <li class="text-links">
        <ul class="text-links-container flex-and-center"
            :class="{'shorten-list': $isHeise}">
          <li v-for="(textLink, i) in textLinks"
              :key="`${textLink.ref}-${i}`"
              :class="`gtm-footer-${textLink.ref}`">
            <a class="text-link has-hover is-hidden-mobile"
               tabindex="0"
               :class="{'hide': textLink.hideDesktop}"
               :aria-label="`Go to ${textLink.ref}`"
               :href="textLink.route ? textLink.route : getUTMLink(textLink.externalLink, 'footer')"
               @click.prevent="textLink.route ?
               createLink(textLink.route, false) :
               createLink(getUTMLink(textLink.externalLink, 'footer'), true)">
              {{ textLink.title }}
            </a>
            <a v-if="!textLink.hideMobile"
               class="text-link has-hover is-hidden-tablet is-hidden-desktop"
               tabindex="0"
               :aria-label="`Go to ${textLink.ref}`"
               :href="textLink.route ?
               textLink.route : getUTMLink(textLink.externalLink, 'footer')"
               @click.prevent="textLink.route ?
               createLink(textLink.route, false) : createLink(getUTMLink(textLink.externalLink, 'footer'), true)">
              {{ textLink.mobileTitle ? textLink.mobileTitle : textLink.title }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
    <ul class="footer-right is-flex">
      <li class="icon-links">
        <ul class="icon-link-container flex-and-center"
            :class="{'space-evenly' : !hasLangOpts}">
          <li v-for="({type, url, icon}, i) in iconLinks"
              :key="`${type}-${i}`"
              :class="`gtm-footer-${type}`"
              class="icon-link has-hover">
            <a :href="url"
               target="_blank"
               tabindex="0"
               :aria-label="`Go to ${appName}'s ${type} page`">
              <i :class="`fab fa-${icon}`" />
            </a>
          </li>
        </ul>
      </li>
      <li v-if="hasLangOpts && !isWix"
          class="language-toggle flex-and-center is-hidden-mobile">
        <a v-if="language.href"
           :href="language.href"
           class="has-hover">
          <b>
            <span class="is-hidden-touch">
              {{ language.title }}
            </span>
            <span class="is-hidden-desktop is-uppercase">
              {{ language.abbr }}
            </span>
          </b>
        </a>
        <button v-else
                @click="saveLanguage(language.key)"
                class="has-hover">
          <b>
            <span class="is-hidden-touch">
              {{ language.title }}
            </span>
            <span class="is-hidden-desktop is-uppercase">
              {{ language.abbr }}
            </span>
          </b>
        </button>
        <div class="border">|</div>
      </li>
      <li class="copyright-text flex-and-center is-hidden-mobile">
        <div class="copyright flex-and-center"
             :class="{'has-border': !hasLangOpts && !$isAjas}">
          <p><i class="fal fa-copyright" /> {{$t('footer.copyright')}} {{ new Date().getFullYear() }}
            <span v-if="$isIsef">
              <a class="has-hover"
                 :href="this.getUTMLink('https://projectboard.world','footer')"
                 target="_blank">
                ProjectBoard
              </a>
            </span>
            <span v-if="!$isIsef && !this.isEngCom">
              <a class="has-hover"
                 :href="this.getUTMLink('https://www.engineering.com/' ,'footer')"
                 target="_blank">
                engineering.com
              </a>
            </span>
            <span v-if="this.isEngCom">
              <a class="has-hover"
                 :href="this.getUTMLink('https://www.engineering.com/' ,'footer')"
                 target="_blank">
                WTWH Media LLC. All Rights Reserved. <br>The material on this site may not be reproduced, distributed, transmitted, cached or otherwise used, except with the prior written permission of WTWH Media.
              </a>
            </span>
            <span v-if="$isMake">
              & <a class="has-hover"
                   :href="this.getUTMLink('https://make.co/','footer')"
                   target="_blank">
                  Make.co
                </a>
            </span>
          </p>
        </div>
      </li>
    </ul>
  </footer>
</template>

<script>
import i18n from '@/i18n'

import language from './mixins'
import utmTracking from '@/mixins/utm-tracking'

const socialUrl = {
  instagram: 'https://www.instagram.com/letsmakeprojects/',
  linkedin: 'https://www.linkedin.com/company/1844762/',
  facebook: 'https://www.facebook.com/engineeringcom/'
}

export default {
  mixins: [language, utmTracking],
  computed: {
    app: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    isWix: function () {
      return this.$route.path === this.$store.getters.iframe.route
    },
    appName: function () {
      switch (this.app) {
        case 'neweng':
          return 'Engineering.com'
        default:
          return 'Make: Project'
      }
    },
    isEngCom: function () {
      return this.$isEngCom
    },
    textLinks: function () {
      const links = [
        {
          title: i18n.t('footer.about'),
          route: this.aboutRoute,
          externalLink: this.aboutExternalUrl,
          ref: 'about',
          show: true
        },
        {
          title: i18n.t('footer.contact'),
          route: 'contact',
          ref: 'contact',
          show: true
        },
        {
          title: i18n.t('footer.termsAndConditions'),
          mobileTitle: i18n.t('footer.termsAndConditionsMobile'),
          route: 'terms',
          ref: 'tou',
          show: ['ysc', 'heise', 'ajas', 'isef', 'make', 'projectboard', 'girls-and-steam', 'society-for-sciencebcm', 'ohiosci', 'cnmiiwsf', 'buckeye', 'sts', 'oasam', 'sigmaxi']
        },
        {
          title: i18n.t('footer.privacyPolicy'),
          route: 'privacy',
          ref: 'tou',
          show: true
        },
        {
          title: i18n.t('footer.faq'),
          route: 'FAQ',
          ref: 'faq',
          hideMobile: true,
          show: ['make']
        },
        {
          title: this.isEngCom ? i18n.t('footer.engAdvertise') : i18n.t('footer.advertise'),
          mobileTitle: i18n.t('footer.advertiseMobile'),
          externalLink: 'https://marketing.engineering.com/media-guide-product-offerings-directory?utm_campaign=home+page+navigation',
          ref: 'advertise',
          show: true
        },
        {
          title: i18n.t('footer.blog'),
          mobileTitle: i18n.t('footer.blog'),
          externalLink: 'https://www.blog.projectboard.world/',
          ref: 'blog',
          show: ['ysc', 'heise', 'ajas', 'isef', 'make', 'projectboard', 'girls-and-steam', 'society-for-sciencebcm', 'ohiosci', 'cnmiiwsf', 'buckeye', 'sts', 'oasam', 'sigmaxi']
        },
        {
          title: i18n.t('footer.faq'),
          mobileTitle: i18n.t('footer.faq'),
          route: 'faq',
          ref: 'faqOAS',
          show: ['ohiosci']
        }
      ]
      return links.filter(link => link.show === true || link.show.includes(this.app))
    },
    iconLinks: function () {
      const links = [
        {
          type: 'instagram',
          url: this.getUTMLink(socialUrl.instagram, 'footer'),
          icon: 'instagram',
          show: ['make', 'ysc', 'heise']
        },
        {
          type: 'linkedin',
          url: this.getUTMLink(socialUrl.linkedin, 'footer'),
          icon: 'linkedin-in',
          show: ['neweng']
        },
        {
          type: 'facebook',
          url: this.getUTMLink(socialUrl.facebook, 'footer'),
          icon: 'facebook-f',
          show: ['neweng']
        },
        {
          type: 'twitter',
          url: this.getUTMLink(this.twitterLink, 'footer'),
          icon: 'twitter',
          show: ['make', 'neweng', 'ysc', 'heise']
        }
      ]
      return links.filter(link => link.show.includes(this.app))
    },
    hasLangOpts: function () {
      return Object.keys(this.language).length > 0
    },
    isContactPage: function () {
      return this.$route.name === 'contact'
    },
    isProjectOrStoryPage: function () {
      return this.$route.name === 'viewProject' || this.$route.name === 'viewStory'
    },
    active: function () {
      return !(this.$route.meta && this.$route.meta.hideFooter)
    },
    title: function () {
      return this.$isStories ? 'engineering.com' : ''
    },
    twitterLink: function () {
      return this.$isProjects ? 'https://twitter.com/makeprojects_' : 'https://twitter.com/engineeringcom'
    },
    aboutRoute: function () {
      return 'about'
    },
    aboutExternalUrl: function () {
      return (this.$isAjas || this.$isYSC)
        ? 'https://projectboard.world/' : (this.$isIsef)
          ? 'https://projectboard.world/about' : null
    }
  },
  methods: {
    createLink: function (route, openWindow) {
      if (route === '') {
        return
      }
      if (openWindow) {
        window.open(route, '_blank')
        return
      }
      this.$router.push({ name: route })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

footer {
  // BASE STYLES
  z-index: 9;
  height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 0.5rem;
  background-color: var(--background-fourth);
  border: 1px solid var(--border-colour);
  color: var(--font-colour);

  // LEFT, RIGHT LAYOUT
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  @media (max-width: 414px) {
    padding: 0.5rem 0.2rem;
  }

  // REUSABLE CLASSES
  .flex-and-center {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .has-hover {
    cursor: pointer;
    &:hover,
    &:focus{
      opacity: 0.8;
    }
  }

  // OVERRIDING DEFAULT LINK COLOR STYLE
  a {
    color: var(--font-colour);
  }

  // SETTING FLEXED ITEMS TO FULL HEIGHT OF CONTAINER IN ORDER TO CENTER PROPERLY
  .text-links-container,
  .icon-link-container {
    height: 100%;
  }

  ul.footer-left {
    .pb-logo { // POWERED BY PROJECTBOARD
      p {
        font-size: 0.65rem;
        text-transform: uppercase;
        padding: 0 7px 0 5px;
        @include touch {
          font-size: 0.6rem;
          padding: 0 5px 0 0;
        }
      }
      img {
        width: 120px;
        @include touch {
          width: 25px;
        }
        @include mobile {
          width: 25px;
        }
        @media (max-width: 414px) {
          width: 25px;
        }
      }
    }
    .text-links { // ABOUT, CONTACT, TERMS
      padding-left: 1.25rem;
      @include touch {
        padding-left: 1rem;
      }
      @include mobile {
        padding-left: 0.5rem;
      }
      .text-link {
        margin: 0 0.7rem;
        display: flex;
        align-items: center;
        font-size: 0.7rem;
        @include touch {
          margin: 0 0.5rem;
        }
        @include mobile {
          margin: 0 0.3rem;
          font-size: 0.65rem;
        }
        &.hide {
          display: none;
       }
      }
      .shorten-list {
        @media (max-width: 446px) {
          .text-link:last-of-type {
            display: none;
          }
        }
        @media (max-width: 416px) {
          .text-link:nth-of-type(3) {
            display: none;
          }
        }
      }
    }
  }

  ul.footer-right {
    .icon-links { // TWITTER, INSTAGRAM ICONS
      .icon-link {
        font-size: 0.85rem;
        display: flex;
        align-items: center;
        margin: 0 0.5rem;
        height: 100%;
        @include mobile {
          font-size: 0.72rem;
          margin: 0 0.35rem;
        }
        a {
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
      .icon-link:last-of-type {
        margin-right: 1rem;
        @include mobile {
          margin-right: 0.5rem;
        }
      }
      .space-evenly {
        .icon-link {
          @include mobile {
            font-size: 0.8rem;
          }
        }
        .icon-link:last-of-type {
          margin-right: 0.5rem;
          @include mobile {
            margin-right: 0.25rem;
          }
        }
      }
    }

    .language-toggle { // ENGLISH, FRENCH, DEUTSCH
      height: 100%;
      padding-right: 0;
      font-size: 0.7rem;
      @include mobile {
        flex-direction: row-reverse;
      }
      button {
        border: none;
        background: none;
        padding: 0;
        height: 100%;
      }
      a,
      button {
        margin-right: 0.4rem;
        @include mobile {
          margin: 0 0 0 0.4rem;
        }
      }
      .border {
        color: $grey-dark;
      }
    }

    .copyright-text {
      font-size: 0.7rem;
      justify-content: flex-end;
      align-items: center;
      .copyright{
        p {
          padding-left: 0.5rem;
        }
        &.has-border p {
          border-left: 1px $grey-dark solid;
        }
      }
    }
  }
}

</style>
